export default __webpack_public_path__ + "static/media/HomeBanner2.d043548a.jpg";